import axios from 'axios';
import { getAxios } from 'hooks/useAxios';
import { ENDPOINTS } from 'services/endpoints';
import { Company } from 'types/company';
import { User } from 'types/user';

export interface IRequestListEmployeesByCompany {
	company: string;
}
export interface IResponseCompanies {
	companies: string[];
	companiesObjects?: Company[];
}

export interface IResponseListEmployeesByCompany {
	CustomUser: [User[]];
}

export interface IRequestCompany {
	id?: string;
	company: string;
	state: string;
	city: string;
	postalCode: string;
	neighborhood: string;
	street: string;
	number: string;
	complement?: string;
	storeLogo?: string;
	managerName: string;
	managerPhone: string;
	managerEmail: string;
	autoAvaliarLogin: string;
	syonetLogin: string;
	cnpj: string;
	nisaSyonetCompanyId: string;
	nisaBiCompanyName: string;
	autoAvaliarCompanyName: string;
}

export interface ISearchCEP {
	cep: string;
	logradouro: string;
	complemento: string;
	unidade: string;
	bairro: string;
	localidade: string;
	uf: string;
	ibge: string;
	gia: string;
	ddd: string;
	siafi: string;
	erro: boolean;
}

export interface ICompaniesParams {
	company?: string;
	city?: string;
	state?: string;
	postal_code?: string;
	neighborhood?: string;
	manager_name?: string;
	page?: number;
	page_size?: number;
}

export interface ICities {
	cities?: string[];
}

export interface IPaginatedCompanies {
	currentPage: number;
	recordsInThisPage: number;
	totalPages: number;
	totalRecords: number;
	results: IRequestCompany[];
}

const api = getAxios();

export const getAllCompanies = async (): Promise<IResponseCompanies> => {
	const response = await api.get<IResponseCompanies>(ENDPOINTS.getCompanies);
	return response?.data;
};

export const registerCompany = async (data: IRequestCompany): Promise<void> => {
	const response = await api.post(ENDPOINTS.createCompany, data);
	return response?.data;
};

export const getCompanyById = async (companyId: string): Promise<IRequestCompany> => {
	const response = await api.get(ENDPOINTS.getCompanyById(companyId));
	return response.data;
};

export const editCompany = async (data: IRequestCompany, companyId: string): Promise<IRequestCompany> => {
	const response = await api.put(ENDPOINTS.editCompany(companyId), data);
	return response.data;
};

export const searchCep = async (cep: string): Promise<ISearchCEP> => {
	const url = `https://viacep.com.br/ws/${cep}/json/`;

	const response = await axios.get<ISearchCEP>(url);

	return response.data;
};

export const getAllCompleteCompanies = async (params?: ICompaniesParams): Promise<IPaginatedCompanies> => {
	const response = await api.get<IPaginatedCompanies>(ENDPOINTS.getAllCompleteCompanies, { params });
	return response?.data;
};

export const getAllCities = async (): Promise<ICities> => {
	const response = await api.get<ICities>(ENDPOINTS.getCities);
	return response?.data;
};
